import { render } from "./CompletedView.vue?vue&type=template&id=11083ba5"
import script from "./CompletedView.vue?vue&type=script&lang=js"
export * from "./CompletedView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programmazione\\Nodejs\\CallER\\webapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__